import(/* webpackMode: "eager", webpackExports: ["CompanyDashboard"] */ "/vercel/path0/src/components/dashboard/company/CompanyDashboard.tsx");
